import React, { Component } from 'react'

export default class Symptoms extends Component {
    render() {
        return (
            <div>
                Hello from Symptoms page
            </div>
        )
    }
}
